module.exports = `${require.publicPath}certificate-bg1.d52db75d.png`;